export default function productUpdatesFilter() {
  const updateListEl = document.querySelectorAll(".product-updates-list");
  if (updateListEl) {
    queryParamHandler();
    showDefaultUpdates();

    updateListEl.forEach((list) => {
      // Listen to tag click in sidebar
      const sidebar = list.querySelector(".product-updates-filter");
      sidebar.addEventListener("click", async (ev) => {
        if (ev.target.classList.contains("product-updates-filter__label")) {
          updateButtons(ev.target);
          await updateContent(ev.target);
          list.scrollIntoView();
        }
      });
      const articleList = list.querySelector(".product-updates-list__list");
      articleList.addEventListener("click", async (ev) => {
        if (ev.target.classList.contains("product-updates-filter__label")) {
          const target = sidebar.querySelector(`[value="${ev.target.value}"]`);
          updateButtons(target);
          await updateContent(target);
          list.scrollIntoView();
        }
      });
      const loadMore = list.querySelector(".product-updates-list__more-button");
      if (loadMore) {
        loadMore.addEventListener("click", async () => {
          // Increment pagination
          const url = new URL(window.location);
          let pageNum = parseInt(url.searchParams.get("page")) + 1;
          url.searchParams.set("page", pageNum);
          history.pushState(null, "", url);
          // Fetch data
          let filter = "";
          if (url.searchParams.get("platforms")) {
            const term = url.searchParams.get("platforms");
            filter = `&filter[taxonomy:product_update_platforms]=${term}`;
          }
          if (url.searchParams.get("tags")) {
            const term = url.searchParams.get("tags");
            filter = `&filter[taxonomy:product_update_tags]=${term}`;
          }
          const query = `/api/collections/product_updates/entries?limit=8&page=${pageNum}&sort=-date${filter}`;
          // Append to DOM
          const response = await fetch(query);
          const updates = await response.json();
          printUpdates(updates.data);
          if (updates.meta.last_page <= pageNum) {
            loadMore.classList.add("hidden");
          }
        });
      }
    });
  }

  function showDefaultUpdates() {
    const updates = document.querySelectorAll(".product-update");
    updates.forEach((update) => update.classList.add("product-update--show"));
  }

  function queryParamHandler() {
    addEventListener("load", async () => {
      const url = new URL(window.location);
      const tagParam = url.searchParams.get("tags");
      const platformParam = url.searchParams.get("platforms");
      let button = null;
      if (tagParam) {
        button = document.querySelector(
          `.product-updates-list__filter .product-updates-filter__label[value="tags_${tagParam}"]`
        );
      }
      if (platformParam) {
        button = document.querySelector(
          `.product-updates-list__filter .product-updates-filter__label[value="platforms_${platformParam}"]`
        );
      }
      if (button) {
        updateButtons(button);
        await updateContent(button);
      }
    });
  }

  async function updateContent(button) {
    const term = button.value;
    const showDefault = !button.classList.contains(
      "product-updates-filter__label--active"
    );
    const loadMore = document.querySelector(
      ".product-updates-list__more-button"
    );
    const listContainer = document.querySelector(".product-updates-list__list");
    listContainer.innerHTML = "";
    if (showDefault) {
      const query = `/api/collections/product_updates/entries?limit=8&sort=-date&page=1`;
      const response = await fetch(query);
      const updates = await response.json();
      if (loadMore) {
        if (updates.meta.last_page <= 1) {
          loadMore.classList.add("hidden");
        } else {
          loadMore.classList.remove("hidden");
        }
      }
      printUpdates(updates.data);
      removeParams();
    } else {
      const type = term.split("_")[0];
      const queryTerm = term.split("_")[1];
      const url = new URL(window.location);
      const query = `/api/collections/product_updates/entries?limit=8&page=1&sort=-date&filter[taxonomy:product_update_${type}]=${queryTerm}`;
      const response = await fetch(query);
      const updates = await response.json();
      if (loadMore) {
        if (updates.meta.last_page <= 1) {
          loadMore.classList.add("hidden");
        } else {
          loadMore.classList.remove("hidden");
        }
      }
      printUpdates(updates.data, term);
      changeQueryParams(type, term);
    }
  }

  function removeParams() {
    if ("URLSearchParams" in window) {
      const url = new URL(window.location);
      // Remove existing filters
      url.searchParams.delete("page");
      url.searchParams.delete("tags");
      url.searchParams.delete("platforms");
      history.pushState(null, "", url);
    }
  }

  function changeQueryParams(type, term) {
    if ("URLSearchParams" in window) {
      const url = new URL(window.location);
      // Remove existing filters, if applicable
      url.searchParams.delete("tags");
      url.searchParams.delete("platforms");
      // Set filter i query string
      url.searchParams.set(type, term.split("_")[1]);
      url.searchParams.set("page", 1);
      history.pushState(null, "", url);
    }
  }

  function updateButtons(button) {
    const active = document.querySelector(
      ".product-updates-filter__label--active"
    );
    if (active && active != button) {
      active.classList.remove("product-updates-filter__label--active");
    }
    button.classList.toggle("product-updates-filter__label--active");

  }

  function printUpdates(updates, term = null) {
    const listContainer = document.querySelector(".product-updates-list__list");
    if (updates.length < 0) return;
    updates.forEach((update) => {
      const template = document.querySelector("#product-update-template");
      const clone = template.content.cloneNode(true);
      const date = new Date(update.date);
      const options = { year: "numeric", month: "long", day: "numeric" };
      const formattedDate = date.toLocaleDateString("en-US", options);
      clone.querySelector(".product-update__date").innerText = formattedDate;
      clone.querySelector(".product-update__body").innerHTML = update.body;
      clone.querySelector(".product-update__title").innerText = update.title;
      if (update.caption) {
        clone.querySelector(".product-update__image-caption").innerText =
          update.caption;
      } else {
        clone.querySelector(".product-update__image-caption").remove();
      }

      const cta = clone.querySelector(".product-update .button");
      if (update.cta.text && update.cta.link) {
        cta.href = update.cta.link;
        cta.innerText = update.cta.text;
      } else {
        cta.remove();
      }

      const tag = clone.querySelector(
        ".product-updates-filter__label:first-child"
      );
      if (update.product_update_tags) {
        tag.innerText = update.product_update_tags.title;
        tag.value = "tags_" + update.product_update_tags.slug;
        if (term && tag.value == term) {
          tag.classList.add("product-updates-filter__label--active");
        }
      } else {
        platform.remove();
      }

      const platform = clone.querySelector(
        ".product-updates-filter__label:last-child"
      );
      if (update.product_update_platforms) {
        platform.innerText = update.product_update_platforms.title;
        platform.value = "platforms_" + update.product_update_platforms.slug;
        if (term && platform.value == term) {
          platform.classList.add("product-updates-filter__label--active");
        }
      } else {
        platform.remove();
      }

      clone.querySelector(".product-update__type").innerText =
        update.update_type.label;
      clone
        .querySelector(".product-update__type")
        .classList.add(`product-update__type--${update.update_type.key}`);
      if (update.featured_image) {
        clone.querySelector(".product-update__image").src =
          update.featured_image.url;
      } else {
        clone.querySelector(".product-update__image-container").remove();
      }

      listContainer.append(clone);
    });
    setTimeout(() => {
      Array.from(listContainer.children).forEach((child) => {
        child.classList.add("product-update--show");
      });
    }, 100);
  }
}
